export default __webpack_public_path__ + "static/media/DamaLUFTCover.3338aed4.jpg";